import React, { useState, Component } from 'react';
import { ViralResultCard } from '../components/Analysis/ViralResultCard';
import { WebsiteHeader } from '../components/Dashboard/WebsiteHeader';
export function DebugPage() {
  const [score, setScore] = useState(92);
  return <div className="min-h-screen bg-[#050505] text-white flex flex-col font-sans" data-id="element-4116">
      <WebsiteHeader data-id="element-4117" />

      <main className="flex-1 max-w-6xl mx-auto w-full px-4 py-12 flex flex-col lg:flex-row gap-12 items-start" data-id="element-4118">
        {/* Controls Panel */}
        <div className="w-full lg:w-1/3 bg-[#0A0A0A] border border-gray-800 rounded-2xl p-8 sticky top-24" data-id="element-4119">
          <h1 className="text-2xl font-black mb-6 tracking-tight" data-id="element-4120">
            Viral Card Debugger
          </h1>

          <div className="mb-8" data-id="element-4121">
            <label className="block text-sm font-mono text-gray-400 mb-4 uppercase tracking-wider" data-id="element-4122">
              Toxicity Score:{' '}
              <span className="text-white font-bold text-lg" data-id="element-4123">{score}%</span>
            </label>
            <input type="range" min="0" max="100" value={score} onChange={e => setScore(parseInt(e.target.value))} className="w-full h-2 bg-gray-800 rounded-lg appearance-none cursor-pointer accent-red-500" data-id="element-4124" />
            <div className="flex justify-between text-xs font-mono text-gray-600 mt-2" data-id="element-4125">
              <span data-id="element-4126">0% (Saint)</span>
              <span data-id="element-4127">100% (Final Boss)</span>
            </div>
          </div>

          <div className="space-y-4" data-id="element-4128">
            <h3 className="text-sm font-mono text-gray-400 uppercase tracking-wider mb-2" data-id="element-4129">
              Quick Test Values
            </h3>
            <div className="grid grid-cols-2 gap-2" data-id="element-4130">
              <button onClick={() => setScore(15)} className="bg-gray-900 border border-gray-800 hover:border-green-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4131">
                15% (Level 1)
              </button>
              <button onClick={() => setScore(45)} className="bg-gray-900 border border-gray-800 hover:border-yellow-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4132">
                45% (Level 2)
              </button>
              <button onClick={() => setScore(75)} className="bg-gray-900 border border-gray-800 hover:border-orange-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4133">
                75% (Level 3)
              </button>
              <button onClick={() => setScore(92)} className="bg-gray-900 border border-gray-800 hover:border-red-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4134">
                92% (Level 4)
              </button>
            </div>
          </div>

          <div className="mt-8 p-4 bg-gray-900 border border-gray-800 rounded-lg" data-id="element-4135">
            <h3 className="text-sm font-bold mb-2" data-id="element-4136">Design Requirements Met:</h3>
            <ul className="text-xs text-gray-400 space-y-2 font-mono" data-id="element-4137">
              <li data-id="element-4138">✓ Charcoal Black (#0A0A0A) background</li>
              <li data-id="element-4139">✓ Neon Red/Cyber White accents</li>
              <li data-id="element-4140">✓ Monospaced tech header</li>
              <li data-id="element-4141">✓ 9:16 Mobile-first aspect ratio</li>
              <li data-id="element-4142">✓ Glowing circular gauge</li>
              <li data-id="element-4143">✓ Dynamic Meme-able Labels</li>
              <li data-id="element-4144">✓ 3 Indicator dots</li>
              <li data-id="element-4145">✓ Validation Quote Box (Serif)</li>
              <li data-id="element-4146">✓ Footer with CTA & Watermark</li>
            </ul>
          </div>
        </div>

        {/* Preview Area */}
        <div className="w-full lg:w-2/3 flex justify-center items-center bg-[#111] border border-gray-800 rounded-2xl p-12 min-h-[800px] relative overflow-hidden" data-id="element-4147">
          {/* Background grid for preview area */}
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none" data-id="element-4148" />

          {/* The Component */}
          <div className="relative z-10 shadow-[0_0_50px_rgba(0,0,0,0.5)]" data-id="element-4149">
            <ViralResultCard score={score} data-id="element-4150" />
          </div>
        </div>
      </main>
    </div>;
}